module.exports = __webpack_public_path__ + "img/01.43bf6a2d.jpg";